import axios from 'axios';
import { FAILURE, REQUEST, SUCCESS } from 'app/shared/reducers/action-type.util';
import moment from 'moment';
// @ts-ignore
import QRCode from 'qrcode';

export const ACTION_TYPES = {
  GET_USER_PROFILE: 'UserInfo/GET_USER_PROFILE',
  FETCH_AUTH: 'UserInfo/FETCH_AUTH',
  ADD_SIM_PKI: 'UserInfo/ADD_SIM_PKI',
  ADD_TOKEN: 'UserInfo/ADD_TOEKN',
  ADD_SMS: 'UserInfo/ADD_SMS',
  ADD_PASSWORD: 'UserInfo/ADD_PASSWORD',
  RESET_PASSWORD: 'UserInfo/RESET_PASSWORD',
  SEND_OTP: 'UserInfo/SEND_OTP',
  VERIFY_OTP: 'UserInfo/VERIFY_OTP',
  DELETE_AUTH: 'UserInfo/DELETE_AUTH',
  UPDATE_AUTH: 'UserInfo/UPDATE_AUTH',
  GET_ATTRIBUTE: 'UserInfo/GET_ATTRIBUTE',
  UPDATE_ATTRIBUTE: 'UserInfo/UPDATE_ATTRIBUTE',
  RESET: 'userInfo/RESET',
  LIST_SESSION: 'userInfo/ListSection',
  GET_PROVINCE: 'UserInfo/ListProvince',
  GET_DISTRICT: 'UserInfo/ListDistrict',
  GET_GUILD: 'UserInfo/ListGuild',
  RESET_INFO_ADDRESS: 'UserInfo/ResetInfoAddress',
  DELETE_GROUP: 'UserInfo/DeleteGroup',
  UPLOAD_FILE: 'Admin/UPLOAD_FILE',
  RESULT_DATA: 'Admin/RESULT_DATA',
  APPOVAL_DATA: 'Admin/APPOVAL_DATA',
  APPOVAL_UPDATE: 'Admin/APPOVAL_UPDATE',
  LIST_FILE: 'Admin/LIST_FILE',
  UPLOAD_FILE_DVC: 'Admin/UPLOAD_FILE_DVC',
  VERIFY_FILE: 'Admin/VERIFY_FILE',
  Update_Data_Residential: 'UserInfo/Update_Data_Residential',
  ADD_AUTH_SMART_CA: 'UserInfo/ADD_AUTH_SMART_CA',
  GET_INFO_MAPPING: 'UserInfo/MAPPING',
  UPDATE_ACCOUNT: 'Account/Update',
  UPDATE_AUTH_SMS_EMAIL: 'UserInfo/UPDATE_AUTH_SMS_EMAIL',
  INFO_USER_APPROVE: 'UserInfo/INFO_USER_APPROVE',
  SEND_OTP_MAPPING: 'UserInfo/SEND_OTP_MAPPING',
  VERIFY_OTP_MAPPING: 'UserInfo/VERIFY_OTP_MAPPING',
  GET_QRCODE: 'UserInfo/GET_QRCODE',
  ADD_APP: 'UserInfo/ADD_APP'
};

const initialState = {
  loading: false,
  errorMessage: null,
  auths: {
    authenticator: [] as any
  } as any,
  response: {} as any,
  resResetPass: {} as any,
  resSendOtp: {} as any,
  resVerifyOtp: {} as any,
  resAddSms: {} as any,
  listAttr: [] as any,
  resUpdateAttr: {} as any,
  listSection: {} as any,
  resAddPassword: {} as any,
  userProfile: {
    attributes: [] as any
  } as any,
  province: [] as any,
  district: [] as any,
  guild: [] as any,
  regTokenFailure: false,
  responseAddSMS: {} as any,
  uploadFile: {} as any,
  uploadfileDVC: {} as any,
  errorMessageUpload: false,
  resultData: {} as any,
  appovalData: {} as any,
  appovalUpdate: {} as any,
  listFile: {} as any,
  verify: {} as any,
  responseAddAuthSmartCA: {} as any,
  infoMapping: {} as any,
  resultUpdate: {} as any,
  resUpdateAuth: {} as any,
  resInfoApprove: [] as any,
  resSendOtpMapping: {} as any,
  resVerifyOtpMapping: {} as any,
  qrCodeUrl: null,
  resAddApp: {} as any,
  resVerifyOtpMappingFailure: false
};

export type UserInfoState = Readonly<typeof initialState>;

// Reducer
export default (state: UserInfoState = initialState, action): UserInfoState => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.LIST_SESSION):
    case REQUEST(ACTION_TYPES.FETCH_AUTH):
    case REQUEST(ACTION_TYPES.ADD_SIM_PKI):
    case REQUEST(ACTION_TYPES.RESET_PASSWORD):
    case REQUEST(ACTION_TYPES.ADD_TOKEN):
    case REQUEST(ACTION_TYPES.ADD_SMS):
    case REQUEST(ACTION_TYPES.ADD_PASSWORD):
    case REQUEST(ACTION_TYPES.SEND_OTP):
    case REQUEST(ACTION_TYPES.VERIFY_OTP):
    case REQUEST(ACTION_TYPES.DELETE_AUTH):
    case REQUEST(ACTION_TYPES.UPDATE_AUTH):
    case REQUEST(ACTION_TYPES.UPDATE_AUTH_SMS_EMAIL):
    case REQUEST(ACTION_TYPES.GET_ATTRIBUTE):
    case REQUEST(ACTION_TYPES.UPDATE_ATTRIBUTE):
    case REQUEST(ACTION_TYPES.GET_USER_PROFILE):
    case REQUEST(ACTION_TYPES.GET_PROVINCE):
    case REQUEST(ACTION_TYPES.GET_DISTRICT):
    case REQUEST(ACTION_TYPES.GET_GUILD):
    case REQUEST(ACTION_TYPES.DELETE_GROUP):
    case REQUEST(ACTION_TYPES.UPLOAD_FILE):
    case REQUEST(ACTION_TYPES.RESULT_DATA):
    case REQUEST(ACTION_TYPES.APPOVAL_DATA):
    case REQUEST(ACTION_TYPES.APPOVAL_UPDATE):
    case REQUEST(ACTION_TYPES.LIST_FILE):
    case REQUEST(ACTION_TYPES.VERIFY_FILE):
    case REQUEST(ACTION_TYPES.Update_Data_Residential):
    case REQUEST(ACTION_TYPES.ADD_AUTH_SMART_CA):
    case REQUEST(ACTION_TYPES.GET_INFO_MAPPING):
    case REQUEST(ACTION_TYPES.UPDATE_ACCOUNT):
    case REQUEST(ACTION_TYPES.INFO_USER_APPROVE):
    case REQUEST(ACTION_TYPES.SEND_OTP_MAPPING):
    case REQUEST(ACTION_TYPES.VERIFY_OTP_MAPPING):

    case REQUEST(ACTION_TYPES.ADD_APP):
      return {
        ...state
      };
    case REQUEST(ACTION_TYPES.GET_QRCODE):
      return {
        ...state,
        qrCodeUrl: null,
        errorMessage: null
      };
    case SUCCESS(ACTION_TYPES.FETCH_AUTH):
      return {
        ...state,
        auths: action.payload.data
      };
    case SUCCESS(ACTION_TYPES.UPDATE_AUTH_SMS_EMAIL):
      return {
        ...state,
        resUpdateAuth: action.payload.data
      };
    case SUCCESS(ACTION_TYPES.ADD_SIM_PKI):
    case SUCCESS(ACTION_TYPES.ADD_TOKEN):
      return {
        ...state,
        response: action.payload.data,
        regTokenFailure: false
      };
    case SUCCESS(ACTION_TYPES.ADD_SMS):
      return {
        ...state,
        responseAddSMS: action.payload.data
      };
    case SUCCESS(ACTION_TYPES.ADD_AUTH_SMART_CA):
      return {
        ...state,
        responseAddAuthSmartCA: action.payload.data
      };
    case FAILURE(ACTION_TYPES.ADD_SIM_PKI):
    case FAILURE(ACTION_TYPES.ADD_TOKEN):
      return {
        ...initialState,
        regTokenFailure: true
      };
    case SUCCESS(ACTION_TYPES.ADD_PASSWORD):
      return {
        ...state,
        resAddPassword: action.payload.data
      };
    case SUCCESS(ACTION_TYPES.RESET_PASSWORD):
      return {
        ...state,
        resResetPass: action.payload.data
      };
    case SUCCESS(ACTION_TYPES.SEND_OTP):
      return {
        ...state,
        resSendOtp: action.payload.data
      };
    case SUCCESS(ACTION_TYPES.VERIFY_OTP):
      return {
        ...state,
        resVerifyOtp: action.payload.data
      };
    case SUCCESS(ACTION_TYPES.GET_ATTRIBUTE): {
      return {
        ...state,
        listAttr: action.payload.data
      };
    }
    case SUCCESS(ACTION_TYPES.UPDATE_ATTRIBUTE): {
      return {
        ...state,
        resUpdateAttr: action.payload.data
      };
    }
    case FAILURE(ACTION_TYPES.UPDATE_ATTRIBUTE): {
      return {
        ...state,
        resUpdateAttr: null
      };
    }
    case SUCCESS(ACTION_TYPES.GET_USER_PROFILE): {
      return {
        ...state,
        userProfile: action.payload.data
      };
    }
    case SUCCESS(ACTION_TYPES.LIST_SESSION):
      // alert(action.payload.data.id);

      return {
        ...state,
        listSection: action.payload.data
      };

    case SUCCESS(ACTION_TYPES.GET_PROVINCE):
      return {
        ...state,
        province: action.payload.data
      };

    case SUCCESS(ACTION_TYPES.GET_DISTRICT):
      // alert(action.payload.data.id);
      return {
        ...state,
        district: action.payload.data
      };

    case SUCCESS(ACTION_TYPES.GET_GUILD):
      // alert(action.payload.data.id);
      return {
        ...state,
        guild: action.payload.data
      };
    case SUCCESS(ACTION_TYPES.UPLOAD_FILE):
      return {
        ...state,
        uploadFile: action.payload.data,
        errorMessageUpload: false
      };
    case SUCCESS(ACTION_TYPES.GET_QRCODE): {
      return {
        ...state,
        loading: false,
        qrCodeUrl: action.payload,
        errorMessage: null
      };
    }
    case SUCCESS(ACTION_TYPES.ADD_APP):
      if (action.payload.data && action.payload.data.status === 'ERROR') {
        return {
          ...state,
          resAddApp: action.payload.data
        };
      } else {
        return {
          ...state,
          resAddApp: { status: 'SUCCESS' }
        };
      }
    case FAILURE(ACTION_TYPES.UPLOAD_FILE):
      return {
        ...state,
        uploadFile: action.payload.data,
        errorMessageUpload: true
      };

    case SUCCESS(ACTION_TYPES.UPLOAD_FILE_DVC):
      return {
        ...state,
        uploadfileDVC: action.payload.data,
        errorMessageUpload: false
      };
    case FAILURE(ACTION_TYPES.UPLOAD_FILE_DVC):
      return {
        ...state,
        uploadfileDVC: action.payload.data,
        errorMessageUpload: true
      };

    case SUCCESS(ACTION_TYPES.RESULT_DATA):
      return {
        ...state,
        resultData: action.payload.data
      };
    case FAILURE(ACTION_TYPES.RESULT_DATA):
      return {
        ...state,
        resultData: action.payload.data
      };

    case SUCCESS(ACTION_TYPES.APPOVAL_DATA):
      return {
        ...state,
        appovalData: action.payload.data
      };

    case SUCCESS(ACTION_TYPES.APPOVAL_UPDATE):
      return {
        ...state,
        appovalUpdate: action.payload.data
      };

    case SUCCESS(ACTION_TYPES.LIST_FILE):
      return {
        ...state,
        listFile: action.payload.data
      };

    case SUCCESS(ACTION_TYPES.VERIFY_FILE):
      return {
        ...state,
        verify: action.payload.data
      };
    case SUCCESS(ACTION_TYPES.INFO_USER_APPROVE):
      return {
        ...state,
        resInfoApprove: action.payload.data
      };
    case SUCCESS(ACTION_TYPES.SEND_OTP_MAPPING):
      return {
        ...state,
        resVerifyOtpMappingFailure: false,
        resSendOtpMapping: action.payload.data
      };
    case SUCCESS(ACTION_TYPES.VERIFY_OTP_MAPPING):
      return {
        ...state,
        resVerifyOtpMapping: {
          ...action.payload.data,
          timestamp: new Date().getTime()
        }
      };

    case ACTION_TYPES.RESET:
      return {
        ...initialState
      };

    case ACTION_TYPES.RESET_INFO_ADDRESS:
      return {
        ...state,
        district: [],
        guild: []
      };
    case SUCCESS(ACTION_TYPES.GET_INFO_MAPPING):
      return {
        ...state,
        infoMapping: action.payload.data
      };
    case SUCCESS(ACTION_TYPES.UPDATE_ACCOUNT):
      return {
        ...state,
        resultUpdate: action.payload.data
      };
    case FAILURE(ACTION_TYPES.GET_QRCODE):
      return {
        ...state,
        errorMessage: action.payload,
        qrCodeUrl: null
      };
    case FAILURE(ACTION_TYPES.ADD_APP):
      return {
        ...state,
        errorMessage: action.payload.response.data.errorKey
      };
    case FAILURE(ACTION_TYPES.VERIFY_OTP_MAPPING): {
      return {
        ...state,
        resVerifyOtpMappingFailure: true
      };
    }
    default:
      return state;
  }
};

const apiUrl = 'api/auth';

// Actions
export const getAuths = (type, name) => ({
  type: ACTION_TYPES.FETCH_AUTH,
  payload: axios.get(apiUrl + '/type', {
    params: {
      type: type,
      name: name
    }
  })
});

export const updateAuth = (newValue, oldValue, type, key) => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.UPDATE_AUTH_SMS_EMAIL,
    payload: axios.post(apiUrl + '/update', null, {
      params: { newValue, oldValue, type, key }
    })
  });
  dispatch(getAuths(null, null));
  return result;
};

export const getUserProfile = () => ({
  type: ACTION_TYPES.GET_USER_PROFILE,
  payload: axios.get('api/attributes')
});

export const getInfoMapping = () => ({
  type: ACTION_TYPES.GET_INFO_MAPPING,
  payload: axios.get('api/attributes/mapping')
});

export const handleAddSim = (cert, userType, email, phone, provider) => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.ADD_SIM_PKI,
    payload: axios.post(apiUrl + '/pki', { cert, userType, email, phone, provider })
  });
  dispatch(getAuths(null, null));
  return result;
};

export const handleAddToken = (signed, cert, otp, userType, email) => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.ADD_TOKEN,
    payload: axios.post(apiUrl + '/usb', { signed, cert, otp, userType, email })
  });
  dispatch(getAuths(null, null));
  return result;
};

export const handleAddSmartCA = dict => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.ADD_AUTH_SMART_CA,
    payload: axios.post(apiUrl + '/smartCA', dict)
  });
  dispatch(getAuths(null, null));
  return result;
};

export const handleAddSMS = (otp, phone) => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.ADD_SMS,
    payload: axios.get(apiUrl + '/phone', {
      params: {
        phone: phone,
        otp: otp
      }
    })
  });
  dispatch(getAuths(null, null));
  return result;
};

export const handleAddPassword = password => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.ADD_PASSWORD,
    payload: axios.post('api/auth/password', null, {
      params: {
        password: password
      }
    })
  });
  dispatch(getAuths(null, null));
  return result;
};

export const handleDeleteAuth = id => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.DELETE_AUTH,
    payload: axios.delete(`${apiUrl}/${id}`)
  });
  dispatch(getAuths(null, null));
  return result;
};

export const handleDeleteGroup = type => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.DELETE_GROUP,
    payload: axios.delete(`/api/auth/del/` + `${type}`)
  });
  dispatch(getAuths(null, null));
  return result;
};

export const handleUpdateAuth = id => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.UPDATE_AUTH,
    payload: axios.put(`${apiUrl}/${id}`)
  });
  dispatch(getAuths(null, null));
  return result;
};

export const handleSendOtp = (phone, type, captcha) => ({
  type: ACTION_TYPES.SEND_OTP,
  payload: axios.get('api/register/otp', {
    params: {
      phone: phone,
      type: type,
      captcha: captcha
    }
  })
});

export const handleResetPassword = (oldPassword, newPassword) => ({
  type: ACTION_TYPES.RESET_PASSWORD,
  payload: axios.post('api/user/password', {
    oldPassword: oldPassword,
    newPassword: newPassword
  })
});

export const getAttribute = () => ({
  type: ACTION_TYPES.GET_ATTRIBUTE,
  payload: axios.get('api/attributes/mapping')
});

export const updateAttribute = (attrs, resources, sic, tax) => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.UPDATE_ATTRIBUTE,
    payload: axios.post('api/attributes/update', { attrs, resources, sic, tax })
  });
  dispatch(getUserProfile());
  return result;
};

export const updateAttributeWithDataResidential = dict => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.Update_Data_Residential,
    payload: axios.post('api/attributes/update/data/residentail', dict)
  });
  dispatch(getUserProfile());
  return result;
};

export const reset = () => ({
  type: ACTION_TYPES.RESET
});

export const resetInfoAddress = () => ({
  type: ACTION_TYPES.RESET_INFO_ADDRESS
});

export const getListSession = () => ({
  type: ACTION_TYPES.LIST_SESSION,
  payload: axios.get('/api/attributes/get', {
    params: {
      claim: 'sessionMetaData'
    }
  })
});

// 1: Tỉnh/Thành phố
// 2: Quận/Huyện
// 3: Phường/Xã
export const getProvince = () => ({
  type: ACTION_TYPES.GET_PROVINCE,
  payload: axios.post('api/administrative/unit', null, {
    params: {
      type: 1
      // parentId: ''
    }
  })
});

export const getDistrict = id => ({
  type: ACTION_TYPES.GET_DISTRICT,
  payload: axios.post('api/administrative/unit', null, {
    params: {
      type: 2,
      parentId: id
    }
  })
});

export const getGuild = id => ({
  type: ACTION_TYPES.GET_GUILD,
  payload: axios.post('api/administrative/unit', null, {
    params: {
      type: 3,
      parentId: id
    }
  })
});

export const getFile = () => ({
  type: ACTION_TYPES.LIST_FILE,
  payload: axios.get('api/user/file/loadfile')
});

export const verifyFile = file => async dispatch => {
  const formData = new FormData();
  formData.append('file', file);
  const result = await dispatch({
    type: ACTION_TYPES.VERIFY_FILE,
    payload: axios.post('api/user/verify', formData, {
      headers: {
        'content-type': 'multipart/form-data'
      }
    })
  });
  return result;
};

export const uploadFile = (value, file) => async dispatch => {
  const formData = new FormData();
  formData.append('file', file);
  const result = await dispatch({
    type: ACTION_TYPES.UPLOAD_FILE,
    payload: axios.post('api/user/file/upload', formData, {
      headers: {
        'content-type': 'multipart/form-data'
      }
    })
  });
  value.umFileId = result.value.data.fileId;
  dispatch(appovalCreate(value));
  return result;
};

export const uploadFileDVC = file => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.UPLOAD_FILE_DVC,
    payload: axios.post('api/user/file/savefile', file)
  });
  return result;
};

export const appovalCreate = param => {
  const result = {
    type: ACTION_TYPES.RESULT_DATA,
    payload: axios.post('/api/user/approval', param)
  };
  return result;
};

export const appovalUpdate = param => {
  const result = {
    type: ACTION_TYPES.APPOVAL_UPDATE,
    payload: axios.put('/api/user/approval', param)
  };
  return result;
};

export const getAppoval = id => ({
  type: ACTION_TYPES.APPOVAL_DATA,
  payload: axios.get('/api/user/approval', {
    params: {
      userid: id
    }
  })
});

export const updateAccount = param => {
  const result = {
    type: ACTION_TYPES.UPDATE_ACCOUNT,
    payload: axios.post('/api/account/update', param)
  };
  return result;
};

export const sendOtp = (id, key) => ({
  type: ACTION_TYPES.VERIFY_OTP,
  payload: axios.get(`api/register/activate/${id}`, {
    params: {
      key: key
    }
  })
});

export const handleGetUserInfo = (username, type, status) => {
  let requestUrl = `api/approval-entries?userID.equals=${username}&type.equals=${type}&status.equals=${status}&page=${0}&size=${1}`;
  return {
    type: ACTION_TYPES.INFO_USER_APPROVE,
    payload: axios.get(requestUrl).catch(error => {
      console.error('Lỗi khi gọi API:', error);
    })
  };
};

/*==================Mapping==========================*/
export const sendOtpMapping = () => ({
  type: ACTION_TYPES.SEND_OTP_MAPPING,
  payload: axios.get('api/bind/otp')
});

export const verifyOtpMapping = (key, value) => ({
  type: ACTION_TYPES.VERIFY_OTP_MAPPING,
  payload: axios.post('api/bind/accept', { key, value })
});
const getAuthHeader = () => {
  const token = sessionStorage.getItem('jhi-access_token');
  return {
    'X-Authorization': `Bearer ${token}`
  };
};

export const getQRCode = () => {
  return dispatch => {
    dispatch({ type: REQUEST(ACTION_TYPES.GET_QRCODE) });

    axios
      .get('api/totp/init', { headers: getAuthHeader() })
      .then(response => {
        const base64Data = response.data.qrCodeUrl;
        const qrCodeString = atob(base64Data);

        QRCode.toDataURL(qrCodeString)
          .then(dataURL => {
            dispatch({
              type: SUCCESS(ACTION_TYPES.GET_QRCODE),
              payload: dataURL
            });
          })
          .catch(error => {
            dispatch({
              type: FAILURE(ACTION_TYPES.GET_QRCODE),
              payload: error
            });
          });
      })
      .catch(error => {
        dispatch({
          type: FAILURE(ACTION_TYPES.GET_QRCODE),
          payload: error
        });
      });
  };
};

export const AddApp = verificationCode => {
  return {
    type: ACTION_TYPES.ADD_APP,
    payload: axios.post(`api/totp`, { verificationCode }, { headers: getAuthHeader() })
  };
};
